/** Trim and lowercase for case-insensitive email comparison. */
export function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}
